// extracted by mini-css-extract-plugin
export default {"container":"Chip_container__Je4YY","closeIcon":"Chip_closeIcon__5L1+g"};